import { CheckIcon, CreditCardIcon, UsersIcon } from "@heroicons/react/outline";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCorporates } from "state/slices/contactPersonCorporates";
import Cookie from "js-cookie";
import { Constants } from "config/constants";
import { getCorporatesForDashboard } from "state/slices/corporatesForDashboard";

const Summary = () => {
  const cookieRole = Cookie.get("role");
  const {
    items,
    totalCount: orgSubscribers,
    getOrganizations,
  } = useSelector((state) => state.contactPersonCorporatesSlice);
  const { corporates, getCorporatesForDashboardStatus } = useSelector(
    (state) => state.corporatesForDashboardSlice
  );
  const { organization, organizationName } = useSelector(
    (state) => state.activeDashboardSlice
  );

  let totalSubscribers = 0;

  if (cookieRole === Constants.COOKIE_ROLES.SUPER_ADMIN) {
    totalSubscribers = orgSubscribers;
  } else {
    totalSubscribers = corporates.totalCount;
  }

  const { stats } = useSelector((state) => state.statsSlice);
  const dispatch = useDispatch();

  const superAdminCards = [
    {
      title: "Active Org Admins",
      value: stats.orgAdminsCount,
      percentage: 0,
      bgColor: "bg-primary text-white",
    },
    {
      title: "Platform MRR",
      value: "0",
      percentage: 0,
    },
    {
      title: "GMV (Est.)",
      value: "0",
      percentage: 0,
    },
  ];

  const orgAdminCards = [
    {
      title: "Total Revenue",
      value: stats.orgAdminsCount,
      percentage: 0,
      bgColor: "bg-primary text-white",
    },
    {
      title: "Your Share",
      value: "0",
      percentage: 0,
    },
    {
      title: "Platform Share",
      value: "0",
      percentage: 0,
    },
  ];

  const subscriptionCards = [
    {
      title: "Total Subscribers",
      value: totalSubscribers,
      icon: UsersIcon,
      percentage: 0,
    },
    {
      title: "Active Subscriptions",
      value: totalSubscribers,
      percentage: 0,
    },
    {
      title: "Total eWallet Value",
      value: "0",
      percentage: 0,
    },
  ];

  const paystackCards = [
    {
      title: "Total Settlements",
      value: "0",
      percentage: 0,
    },
    {
      title: "Pending Settlements",
      value: "0",
      percentage: 0,
    },
  ];

  let overallCards = [
    {
      title: "Subscriptions",
      cards: subscriptionCards,
    },
    {
      title: "Paystack",
      cards: paystackCards,
    },
  ];

  if (cookieRole === Constants.COOKIE_ROLES.SUPER_ADMIN) {
    overallCards.unshift({
      title: "Dashboard",
      cards: superAdminCards,
    });
  } else {
    overallCards.unshift({
      title: "Dashboard",
      cards: orgAdminCards,
    });
  }

  useEffect(() => {
    if (cookieRole === Constants.COOKIE_ROLES.SUPER_ADMIN) {
      dispatch(
        getCorporates({
          queryParams: {
            page: "corporate-directors-shareholders",
            subscribers: true,
          },
        })
      );
    } else {
      if (organization?.names?.companyRegNumber) {
        dispatch(
          getCorporatesForDashboard({
            companyRegNumber: organization?.names?.companyRegNumber,
            companyDashboard: !organization.partnershipType,
            subscribers: true,
          })
        );
      }
    }
  }, [cookieRole, organization]);

  return (
    <div className="flex flex-col gap-8">
      {/** Summary cards */}
      {overallCards.map((overall) => (
        <div>
          <div className="mb-4">
            <h2 className="text-primary font-semibold">
              {overall.title} Overview
            </h2>
            <p className="text-sm">
              Key metrics for your organization's subscriptions
            </p>
          </div>
          <div
            className={`grid grid-cols-1 ${
              overall.cards.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"
            }  gap-4`}
          >
            {overall.cards.map((card) => (
              <div
                key={card.title}
                className={`p-4 rounded-lg ${
                  card?.bgColor ? card.bgColor : `bg-white`
                } shadow flex flex-col justify-between gap-3 pb-10`}
              >
                <p className="text-sm">{card.title}</p>
                <div>
                  <p
                    className={`text-2xl font-semibold ${
                      card?.bgColor ? "text-white" : "text-black"
                    }`}
                  >
                    {card.value}
                  </p>
                  <p className="text-xs">
                    + {card.percentage} % from last month
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Summary;
